import { __values } from "tslib";
export function extractHeadersFromAxiosResponse(response) {
    var e_1, _a;
    var headers = [];
    try {
        for (var _b = __values(Object.keys(response.headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var headerKey = _c.value;
            headers.push({
                header: headerKey,
                value: response.headers[headerKey]
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return headers;
}
//# sourceMappingURL=headers-helper.js.map